import React, { useEffect, useState } from 'react';
import InputForm from '../../../InputT';
//import "../../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box } from '@mui/material';
import { Button, Input, Spin, Table } from 'antd';
import { SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import { Crypter } from '../../../../Functions/Security/Crypter';
import DataType from '../../../../Types/DataTablePiclist';
import Datas from '../../../../Data/Data.json'
import File from '../../../File';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SearchModal from '../../../SearchModal';
import Billetage from '../../../Billetage';
import SweetAlert from "sweetalert2";
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';

const columns: ColumnsType<DataTypeTable> = [
  {
    title: 'N° Identification',
    dataIndex: 'NUMIDENTI',
  },
  {
    title: 'Type Garantie',
    dataIndex: 'typgar',
  },
  {
    title: 'Localisation',
    dataIndex: 'LOCAL',
  },
  {
    title: 'Valeur Garantie',
    dataIndex: 'VALGARANTI',
  },
  {
    title: 'Désignation',
    dataIndex: 'DESIGNATION',
  },
  {
    title: 'Date Début',
    dataIndex: 'DATDEB',
  },
  {
    title: 'Date Fin',
    dataIndex: 'DATFIN',
  },
  {
    title: 'Commentaire',
    dataIndex: 'TEXTCOMMEN',
  }
];

let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }


let searchTypAdr: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }



//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchSituationFamiliale: Params = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
let searchProspect: Params = { CodeAgence: '', Table: "DEMARC", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchClassRisque: Params = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchUniteInstitutionnel: Params = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegimeMatrimonial: Params = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
//
let searchNiveauInstruction: Params = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchEthnie: Params = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCateGo: Params = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchZoneGeo: Params = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchCpt: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "plc2", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: Params = { CodeAgence: '', Table: "CCOMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGroupUtilis: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGarantie: Params = { CodeAgence: '', Table: "GARANTIE", Colonne1: "", Colonne2: "", Colagence: '101', Choix: 3 }
let searchTypeGrantie: Params = { CodeAgence: '', Table: "TYPEGARANTIE", Colonne1: "codgar", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGarantieForm: Params = { CodeAgence: '', Table: "GARANTIE", Colonne1: "codgar", Colonne2: "DESIGNATION", Colagence: '101', Choix: 22 }



function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  const [loading, setLoading] = useState(false)
  const [searchCaisse, setSearchCaisse] = useState<Params>({ CodeAgence: user.codage, Table: "CAI", Colonne1: "NODECE", Colonne2: "LECEON", colfiltre: "CDETAT", valfiltre: "50", Colagence: 'AEGECE', Init: user.coduti, Choix: 22 })

  // useEffect(() => {
  //   try {
  //     if (!props.form.getFieldValue("DateOpe")) {
  //       props.form.setFieldValue("DateOpe", user.datjour)
  //     }
  //   } catch (error) {

  //   }
  // })


  // let searchCaisse1: Params = { CodeAgence: '10001', Table: "CAI", Colonne1: "NODECE", Colonne2: "LECEON", colfiltre: "CDETAT", valfiltre: "50", Colagence: 'AEGECE', Init: user.coduti, Choix: 22 }
  let searchAgence: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Init: user.codage, Choix: 22 }

  function loadRecepteur(recepteur: string) {
    //alert(user.coduti)
    let search: ParamsPicklist = { CodeAgence: '', Table: "CAI", Colonne1: "NODECE", Colonne2: "", Colagence: '', Init: recepteur, Choix: 31 }

    setLoading(true)
    //form.resetFields()
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))

          console.log(res)
          if (res.StatutCode == 200) {
            let cais = res.Result.Table[0]

            if (cais.NODECE == props.form.getFieldValue("NODECE")) {
              props.form.setFieldValue("NODECE_RECEP", "")
              props.form.setFieldValue("lib_NODECE_RECEP", "")
              props.form.setFieldValue("CAIUTI_RECP", "")
              props.form.setFieldValue("NUMCPT_RECP", "")

              SweetAlert.fire({ title: "Emission de fonds impossible: choisir une caisse différente avant de contunuer", icon: "warning" })
            }
            else {
              if (cais.CDETAT == "50") {
                props.form.setFieldValue("CAIUTI_RECP", res.Result.Table[0].CAIUTI)
                props.form.setFieldValue("NUMCPT_RECP", res.Result.Table[0].NUMCPT)

              } else {
                props.form.setFieldValue("NODECE_RECEP", "")
                props.form.setFieldValue("lib_NODECE_RECEP", "")
                props.form.setFieldValue("CAIUTI_RECP", "")
                props.form.setFieldValue("NUMCPT_RECP", "")

                SweetAlert.fire({ title: "Le caisse " + res.Result.Table[0].NODECE + "(" + res.Result.Table[0].LECEON + ") n'est pas ouverte", icon: "warning" })
              }
            }


          }
          else {
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  // function getToatal() {
  //   props.form.setFieldValue('TotalBilletage',
  //     formatNumber(
  //       parseInt((props.form.getFieldValue("NOMB01") ? props.form.getFieldValue("NOMB01") : 0)) * 10000 +
  //       parseInt((props.form.getFieldValue("NOMB02") ? props.form.getFieldValue("NOMB02") : 0)) * 5000 +
  //       parseInt((props.form.getFieldValue("NOMB03") ? props.form.getFieldValue("NOMB03") : 0)) * 2000 +
  //       parseInt((props.form.getFieldValue("NOMB04") ? props.form.getFieldValue("NOMB04") : 0)) * 1000 +
  //       parseInt((props.form.getFieldValue("NOMB05") ? props.form.getFieldValue("NOMB05") : 0)) * 500 +
  //       parseInt((props.form.getFieldValue("NOMB06") ? props.form.getFieldValue("NOMB06") : 0)) * 500 +
  //       parseInt((props.form.getFieldValue("NOMB07") ? props.form.getFieldValue("NOMB07") : 0)) * 100 +
  //       parseInt((props.form.getFieldValue("NOMB08") ? props.form.getFieldValue("NOMB08") : 0)) * 50 +
  //       parseInt((props.form.getFieldValue("NOMB09") ? props.form.getFieldValue("NOMB09") : 0)) * 25 +
  //       parseInt((props.form.getFieldValue("NOMB10") ? props.form.getFieldValue("NOMB10") : 0)) * 10 +
  //       parseInt((props.form.getFieldValue("NOMB11") ? props.form.getFieldValue("NOMB11") : 0)) * 5 +
  //       parseInt((props.form.getFieldValue("NOMB12") ? props.form.getFieldValue("NOMB12") : 0)) * 2 +
  //       parseInt((props.form.getFieldValue("NOMB13") ? props.form.getFieldValue("NOMB13") : 0)) * 1)
  //   )
  // }

  // useEffect(() => {
  //   getToatal()
  // })

  // USER TOKEN
  const authHeader = useAuthHeader()
  return (
    <div className='tabItem' style={{ height: "700px" }}>
      <div >
        <Box fontStyle="inherit" className='border border-left' width={"85%"} position={"absolute"}>
          <Spin spinning={loading}>
            <Box display={"flex"} fontStyle="inherit">

              <Box fontStyle="inherit" className='bordure1' width={"50%"}>
                <legend>Information sur la caisse emettrice</legend>
                {/* <Box display={"flex"} fontStyle="inherit"> */}
                <InputForm notRequired width={80} disabled label='Numéro de caisse' name='NODECE' type='text' error='mobile' />
                <InputForm notRequired width={50} disabled label='' name='LECEON' type='text' error='mobile' />
                <InputForm notRequired disabled label="Nom de l'utilisateur" icon={<SwipeUp color='disabled' fontSize='small' />} name='CAIUTI' type='text' error='mobile' /><hr />
                <InputForm notRequired disabled label='N° de compte' icon={<SwipeUp color='disabled' fontSize='small' />} name='NUMCPT' type='text' error='mobile' />
                {/* </Box> */}
              </Box>

              <Box fontStyle="inherit" className='bordure1' width={"50%"}>
                <legend>Information sur la caisse receptrice</legend>
                <SearchModal handleFunction={(codage: string) => {
                  setSearchCaisse(
                    { CodeAgence: codage, Table: "CAI", Colonne1: "NODECE", Colonne2: "LECEON", colfiltre: "CDETAT", valfiltre: "50", Colagence: 'AEGECE', Init: user.coduti, Choix: 22 }
                  )
                }} form={props.form} Titre="Agence" defaultCode={user.codage} defaultLibelle={user.agence} label='Agence' name='CODAGE' Parametre={searchAgence} />
                <SearchModal handleFunction={(recepteur: string) => { loadRecepteur(recepteur) }} form={props.form} Titre="Recherche Caisse" label='Caisse receptrice' name='NODECE_RECEP' Parametre={searchCaisse} />
                <InputForm width={10} disabled label='Compte recepteur' icon={<SwipeUp color='disabled' fontSize='small' />} name='NUMCPT_RECP' type='text' error='mobile' />
                <InputForm width={10} disabled label='Intitulé compte' icon={<SwipeUp color='disabled' fontSize='small' />} name='CAIUTI_RECP' type='text' error='mobile' />

              </Box>

            </Box>

            <Box display={"flex"} fontStyle="inherit" className='bordure1' >
              <Box width={"50%"}>
                <InputForm money label='Montant Operation' icon={<SwipeUp color='disabled' fontSize='small' />} name='montantOpe' type='number' error='mobile' /><hr />
              </Box>
              <Box width={"50%"}>
                <InputForm disabled={false} label='Libellé' icon={<SwipeUp color='disabled' fontSize='small' />} name='lib_CODOPE' type='text' error='mobile' />
              </Box>
            </Box>

            <Billetage form={props.form} withTatal />

            <Box display={"flex"} fontStyle="inherit" >
              <Box width={"50%"}>
                <InputForm disabled label='Code Ope' name='CODOPE' type='text' error='mobile' />
              </Box>
              <Box width={"50%"}>
                <InputForm disabled label='Date Operation' icon={<SwipeUp color='disabled' fontSize='small' />} name='DateOpe' type='date' error='mobile' />
              </Box>
            </Box>

          </Spin>
        </Box>
      </div>
    </div>
  )
}

export default Tab1;  
